import api from '../config/api';

export interface Audio {
  id: number;
  titre: string;
  personne: string;
  categorie: string;
  description?: string;
  audio_file: string;
  duree_secondes?: number;
  duree_formatee?: string;
  photo?: string;
  nombre_ecoutes: number;
  nombre_downloads: number;
  nombre_likes: number;
  is_liked: boolean;
  date_creation?: string;
}

export interface HistoriqueEcoute {
  id: number;
  audio: Audio;
  date_ecoute: string;
}

export interface Favori {
  id: number;
  type_contenu: string;
  objet_id: number;
  created_at: string;
}

export interface PaginatedResponse<T> {
  results: T[];
  count: number;
  next: string | null;
  previous: string | null;
}

export const audioService = {
  // Liste des audios
  getAll: async (page: number = 1, pageSize: number = 6, filters?: { categorie?: string; personne?: string; search?: string }): Promise<PaginatedResponse<Audio>> => {
    const params: any = { page, page_size: pageSize };
    if (filters?.categorie) params.categorie = filters.categorie;
    if (filters?.personne) params.personne = filters.personne;
    if (filters?.search) params.search = filters.search;
    const response = await api.get('/mediatheque/audios/', { params });
    if (response.data.results) {
      return {
        results: response.data.results,
        count: response.data.count || response.data.results.length,
        next: response.data.next || null,
        previous: response.data.previous || null
      };
    }
    const allData = Array.isArray(response.data) ? response.data : [response.data];
    return {
      results: allData,
      count: allData.length,
      next: null,
      previous: null
    };
  },

  getById: async (id: number): Promise<Audio> => {
    const response = await api.get(`/mediatheque/audios/${id}/`);
    return response.data;
  },

  // Liker/unliker
  like: async (id: number): Promise<{ liked: boolean }> => {
    const response = await api.post(`/mediatheque/audios/${id}/like/`);
    return response.data;
  },

  // Enregistrer l'écoute
  ecouter: async (id: number): Promise<void> => {
    await api.post(`/mediatheque/audios/${id}/ecouter/`);
  },

  // Télécharger
  telecharger: async (id: number): Promise<void> => {
    await api.post(`/mediatheque/audios/${id}/telecharger/`);
  },

  // Historique
  getHistorique: async (): Promise<HistoriqueEcoute[]> => {
    const response = await api.get('/mediatheque/historique/');
    return response.data.results || response.data;
  },

  // Favoris
  getFavoris: async (): Promise<Favori[]> => {
    const response = await api.get('/mediatheque/favoris/');
    return response.data.results || response.data;
  },

  addFavori: async (type_contenu: string, objet_id: number): Promise<Favori> => {
    const response = await api.post('/mediatheque/favoris/', { type_contenu, objet_id });
    return response.data;
  },

  removeFavori: async (id: number): Promise<void> => {
    await api.delete(`/mediatheque/favoris/${id}/`);
  },
};

